import { ClickAwayListener } from '@mui/material';
import { Fade } from '@mui/material';
import { Popper } from '@mui/material';
import React from 'react';

interface EditRubricPopupProps {
  children: React.ReactNode;
  anchorEl: HTMLAnchorElement | null;
  open: boolean;
  onClose: () => void;
}

export const EditRubricPopup: React.FC<EditRubricPopupProps> = ({
  children,
  anchorEl,
  open,
  onClose,
}) => {
  return (
    <Popper
      anchorEl={anchorEl}
      open={open}
      sx={{
        zIndex: 9999,
      }}
      transition
      modifiers={[
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
      ]}
    >
      {({ TransitionProps }) => (
        <ClickAwayListener onClickAway={onClose}>
          <div>
            <Fade {...TransitionProps} timeout={350}>
              <div className="shadow-soft-xl bg-white rounded-md z-tooltip">
                {children}
              </div>
            </Fade>
          </div>
        </ClickAwayListener>
      )}
    </Popper>
  );
};
